<template>
  <helper-input-btn>
    <erp-input
        ref="input"
        @input="__set"
        slot="input"
        simple-border
        v-model="description"
        @keydown.enter="searchReu"
        readonly
    >
    </erp-input>
    <a @click="searchReu"><i class="erp-icon search min"></i> </a>
    <u-icon name="plus-circle" type="fa" icon-style="light" class="m-l-xs cursor-pointer" @click.native="abrirCadastro" title="Cadastrar réu"/>
  </helper-input-btn>
</template>

<script>
import InputMixin from '../../../../../reuse/input/mixin'
import {HelperInputBtn} from 'uloc-vue-plugin-erp'
import searchReu from '../window/search/SearchReu'
import windowReu from '../window/windowReu'

export default {
  name: 'ReuInput',
  mixins: [InputMixin],
  props: ['router'],
  data () {
    return {
      findedData: null,
      description: null
    }
  },
  components: {HelperInputBtn},
  methods: {
    __updateInternal() {
      this.updateInternal((v) => v.id + ' - ' + v.descricao)
      this.$emit('selecionaReu', this.findedData)
    },
    abrirCadastro () {
      let router = this.$router || this.router
      let routeData = router.resolve({name: 'pessoas', query: {tags: 'reu'}})
      window.open(routeData.href, '_blank')
    },
    searchReu,
    windowReu
  }
}
</script>
